module.exports = __webpack_public_path__ + "static/media/verify-ds-isinvalid.266f7cd5.svg";